module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.listObj), function(value, key) {
    return _c("ShopCars", {
      tag: "div",
      attrs: {
        "shop": key,
        "cars": value
      }
    }, [_vm._v("other-shop")])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-29af3b04!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components-buy/ListContain/ListMain/OtherShop.vue
// module id = 845
// module chunks = 5